import { render, staticRenderFns } from "./CreateAPlan.vue?vue&type=template&id=f47b0bbe&scoped=true&"
import script from "./CreateAPlan.vue?vue&type=script&lang=ts&"
export * from "./CreateAPlan.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAPlan.vue?vue&type=style&index=0&id=f47b0bbe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47b0bbe",
  null
  
)

export default component.exports